<template>
  <error-page>
    <div>
      <h1>404</h1>
      <h2>{{ $t('errors.404.subtitle') }}</h2>
      <p>{{ $t('errors.404.description') }}</p>
      <router-link to='/'>
        <x-button class='md-raised md-primary dark'>{{ $t('buttons.home') }}</x-button>
      </router-link>
    </div>
  </error-page>
</template>

<script>
  import errorPage from './error'

  export default {
    name: 'error-404',
    components: {
      'error-page': errorPage
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
</style>
